export const otpModalI18n = {
  title: {
    en: 'Check your email',
  },
  explanation: {
    en: "We've sent you a 6-digit code to verify your email address. Please enter it below.",
  },
  inputPlaceholder: {
    en: '6-digit code',
  },
} as const;
